const howItWorks = [
    {
        id: 1,
        image: 'insights/howItWorks/1.png',
        title: 'Design Study',
        description: 'Start by asking a business question and let Peekage AI automatically generate an optimized study for you, or craft your study from scratch.',
    },
    {
        id: 2,
        image: 'insights/howItWorks/2.png',
        title: 'Select Recruitment Criteria',
        description: 'Build your segments using over 200 consumer attributes or utilize our instant screening feature to incorporate additional screening criteria as needed.',
    },
    {
        id: 3,
        image: 'insights/howItWorks/3.png',
        title: 'Build Questionnaire',
        description: 'Review your pre-filled questionnaire and insert expert-designed questions from our question bank or create your own from scratch using over 20 different question types.',
    },
    {
        id: 4,
        image: 'insights/howItWorks/4.png',
        title: 'Implement Logic',
        description: 'Implement logic and pipelining into your questionnaire to craft various user journeys.',
    },
    {
        id: 5,
        image: 'insights/howItWorks/5.png',
        title: 'Launch Campaign',
        description: 'Launch your campaign and monitor live analytics as data flows in.',
    },
    {
        id: 6,
        image: 'insights/howItWorks/6.png',
        title: 'Review & Analyze Data',
        description: 'Utilize advanced reporting & data visualization to get a holistic view of incoming data. ',
    },
    {
        id: 7,
        image: 'insights/howItWorks/7.png',
        title: 'Utilize Actionable Insight',
        description: 'Leverage Peekage recommendations and slice and dice data based on user attributes or responses.',
    },
    {
        id: 8,
        image: 'insights/howItWorks/8.png',
        title: 'Export Data',
        description: 'Easily export and incorporate data into your reports and presentations.',
    },
];

export default howItWorks;
